export async function getGenres() {
    const urlAPI = process.env.REACT_APP_URL_API;
    const urlEndpoint = urlAPI + '/catalog/getGenres.php';

    try {
        let response = await fetch(urlEndpoint, {
            method: 'GET',
            headers: new Headers({
    
            }),
        });
        let responseJson = await response.json();
        if(responseJson !== null) {
            let arrData = [];
            arrData = responseJson;

            return arrData;
        }
    } catch (error) {
        console.log('SbC fetch error genres: ', error.message);
    }
}



